import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnLU: CultureInfo = {
  name: 'en-LU',
  displayName: 'English (Luxembourg)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-LU',
  parent: CultureInfoEn
};
